'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.departments', {
            url: '/departments',
            templateUrl: 'dashboard-departments/dashboard-departments.html',
            controller: 'dashboardDepartmentsCtrl as ctrl',
            resolve: {
                clients: [
                  "Client",
                  function (Client) {
                    return Client.find({
                      filter: {
                        where:{"isOU":true},
                        include: ["owners"],
                      },
                    }).$promise.then(function (clients) {
                      return clients;
                    });
                  },
                ],
              },
            data: {
                authorizedRoles: ['admin','owner']
            }
        });
};
